import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const PHONE = '+91-8796769013';
  const EMAIL = 'shristiveda284@gmail.com';
  const WHATSAPP = '+918796769013';
  const WHATSAPP_MSG = encodeURIComponent('नमस्ते! मुझे परामर्श चाहिए।');

  return (
    <footer className="footer">
      <div className="footer-main container">
        <div className="footer-brand">
          <div className="footer-logo">
            {/* <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
              <circle cx="22" cy="22" r="22" fill="rgba(201,150,58,0.15)" />
              <path d="M22 12 C17 12 13 16 13 22 C13 28 17 32 22 32" stroke="#c9963a" strokeWidth="2.5" strokeLinecap="round"/>
              <path d="M22 12 C27 12 31 16 31 22 C31 28 27 32 22 32" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
              <circle cx="22" cy="10" r="3.5" fill="#c9963a"/>
            </svg> */}
            <div>
              <div className="footer-brand-name">SHRISTIVEDA</div>
              <div className="footer-brand-sub">PVT LIMITED</div>
            </div>
          </div>
          <p className="footer-tagline">महिलाओं के स्वास्थ्य के लिए आयुर्वेदिक समाधान। प्रकृति की शक्ति, विज्ञान का आधार।</p>
          <div className="footer-badges">
            <span>🌿 100% आयुर्वेदिक</span>
            <span>🛡️ कोई साइड इफेक्ट नहीं</span>
          </div>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>संपर्क करें</h4>
          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <a href={`tel:${PHONE}`}>{PHONE}</a>
          </div>
          <div className="contact-item">
            <span className="contact-icon">✉️</span>
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
          </div>
          <div className="contact-item">
            <span className="contact-icon">💬</span>
            <a href={`https://wa.me/${WHATSAPP}?text=${WHATSAPP_MSG}`} target="_blank" rel="noreferrer">
              WhatsApp पर बात करें
            </a>
          </div>
          <div className="contact-item">
            <span className="contact-icon">📍</span>
            <span>India</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} Shristiveda Pvt Limited. All rights reserved.</p>
          <p className="footer-disclaimer">
            Disclaimer: यह जानकारी केवल शैक्षिक उद्देश्य के लिए है। किसी भी स्वास्थ्य समस्या के लिए योग्य चिकित्सक से परामर्श लें।
          </p>
        </div>
      </div>
    </footer>
  );
}
